/**=========================================================
 * Module: app-messages.js
 * Messages list
 =========================================================*/

App.directive('appMessages', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/messages.html',
      restrict: 'E',
      replace: true,
      controller: 'MessagesController',
      scope: { 
          project: '=project',
          type: '@type',
          disabled: '=disabled'
        }
  };

});